// ===================================================
// Единая проверка: виден ли маршрут/ссылка при allowlist `activeModules`
// (дублирует правила `block()` в config/sidebar.config.js).
// Использование: левый Sidebar, HelperSidebar, любые списки быстрых ссылок.
// ===================================================

/**
 * @param {string} modName
 * @param {string[]|undefined} activeModules
 */
export function isModuleKeyAllowed(modName, activeModules) {
  if (Array.isArray(activeModules) && activeModules.includes('all')) {
    return true;
  }
  if (!Array.isArray(activeModules) || !activeModules.includes(modName)) {
    return false;
  }
  return true;
}

/**
 * Совместимость с прежним `isModuleAllowed(href, modName, ...)` в sidebar.
 * @param {string} href
 * @param {string} modName
 * @param {string[]|undefined} activeModules
 */
export function isModuleAllowedByHref(href, modName, activeModules) {
  if (!href) return true;
  return isModuleKeyAllowed(modName, activeModules);
}

/**
 * true = ссылку можно показывать; false = скрыть (модуль выключен в allowlist).
 * @param {string} [href]
 * @param {string[]|undefined} activeModules
 * @param {{ walletUrl?: string, billingUrl?: string }} [urls] — если не заданы, внешние wallet/billing не фильтруются по равенству
 */
export function isHrefVisibleWithActiveModules(href, activeModules, urls = {}) {
  const h = href || '';
  const { walletUrl, billingUrl, marketUrl } = urls;

  const block = (pathPrefix, modName) =>
    h.startsWith(pathPrefix) && !isModuleAllowedByHref(pathPrefix, modName, activeModules);

  if (block('/modules/orders', 'orders')) return false;
  if (block('/modules/delivery', 'delivery')) return false;
  if (block('/modules/logistics', 'logistics')) return false;
  if (block('/modules/crm', 'crm') || block('/crm', 'crm')) return false;
  if (block('/modules/hrm', 'hrm')) return false;
  if (block('/modules/files', 'files')) return false;
  if (block('/modules/search', 'search')) return false;
  if (block('/modules/bonus', 'bonus')) return false;
  if (block('/kassa', 'kassa') || block('/modules/kassa', 'kassa')) return false;
  if (block('/documents', 'docs')) return false;
  if (block('/modules/shop', 'shop')) return false;
  if (block('/modules/company-services-booking', 'shop')) return false;
  if (block('/modules/feed', 'feed')) return false;
  if (block('/analytics', 'analytics')) return false;
  if (block('/integrations', 'integrations') || block('/api-integration', 'integrations')) return false;
  if (block('/cost-details', 'finance')) return false;
  if (block('/finance-overview', 'finance')) return false;
  if (walletUrl && h === walletUrl && !isModuleAllowedByHref(walletUrl, 'finance', activeModules)) {
    return false;
  }
  if (billingUrl && h === billingUrl && !isModuleAllowedByHref(billingUrl, 'finance', activeModules)) {
    return false;
  }
  if (marketUrl && h === marketUrl && !isModuleAllowedByHref(marketUrl, 'market', activeModules)) {
    return false;
  }
  if (block('/modules/torg', 'torg')) return false;
  if (block('/modules/wms', 'sklad')) return false;
  if (block('/modules/finance', 'finance')) return false;
  if (block('/modules/widgets', 'widgets')) return false;
  if (block('/modules/notifications', 'notifications')) return false;
  if (block('/modules/power', 'power')) return false;
  if (block('/modules/legal', 'legal')) return false;
  if (block('/modules/support', 'support')) return false;
  if (block('/waygen', 'waygen')) return false;
  if (block('/modules/services', 'services')) return false;

  return true;
}
